import React, { useEffect } from "react";
import { usePagination } from "./pagination-hook";
import { ChevronLeft, ChevronRight } from "react-bootstrap-icons";
import "./Pagination.css"
import { Col, Container, Form, Row } from "react-bootstrap";
import SearchSelect from "../common/SearchSelect";

export default function Pagination(props) {

  const { setCurrentPage, totalCount, currentPage, pageSize } = props;

  const paginationRange = usePagination({
    currentPage,
    totalCount,
    pageSize,
  });



  let lastPage = paginationRange?.totalPageCount;
  let pageText = `${paginationRange?.startInd}-${paginationRange?.endInd} of ${totalCount} ${props.dataType}`;


  const onPageChange = () => {
    let rows = [];
    for (let i = 1; i <= lastPage; i++) {
      rows.push(i);
    }
    return rows;
  };

  let pageList = onPageChange();

  const onNext = () => {
    setCurrentPage(currentPage + 1);
  };

  const onPrevious = () => {
    if (currentPage > 1) {
      setCurrentPage(currentPage - 1);
    } else {
      setCurrentPage(1);
    }
  };

  return (
    <div className="pagination-container">
      <div className="pagintion-bar-border"></div>
      <Row className="pagintion-bar">
        <Col lg={8} md={4}>
          <span className="page-text">{pageText}</span>
        </Col>
        <Col lg={4} md={8}>
          <div className="page-right">
            <span>The page you're on</span>
           
              <SearchSelect
                data={pageList}
                className="page-list"
                name="currentPage"
                value={currentPage}
                onChange={(e) => {
                  setCurrentPage(Number(e.target.value));
                }}
              ></SearchSelect>
            {/* </Col> */}
            <span className="bar">|</span>
            <ChevronLeft
              size={18}
              onClick={onPrevious}
              className={currentPage === 1 ? "disabled" : ""}
            /> Pre <span className="bar">|</span> Nxt
            <ChevronRight
              size={18}
              onClick={onNext}
              className={currentPage === lastPage ? "disabled" : ""}
            />
          </div>
        </Col>
      </Row>
    </div>
  );
};


